<template>
    <div style="margin: 0 auto" :style="$vuetify.breakpoint.mobile ? 'width: 100%; padding: 0 30px;' : 'width: 1024px'">

        <fieldset v-for="(data, data_key) in datas.document_type" :key="data_key" v-show="data.show" style="min-height: 100px; margin-bottom: 30px; padding: 0 10px; border-radius: 5px; border-width: 0; border: 2px solid #e4e4e4;">
            <legend style="padding: 0 6px; font-size: 14px; font-weight: bold;">{{ data.name }}</legend>
            <div style="float: left; border: 1px solid #d6d3d3; padding: 5px; margin-bottom: 10px; margin-right: 10px;" v-for="(doc, key_doc) in data.files" :key="key_doc">
                <img :src="doc" alt="" style="width: 100px; height: 100px;">
            </div>
            <div style="clear:both"></div>
        </fieldset>
    
    </div>
</template>

<script>

    import OptionDataMixin from "../../../../mixins/optionDataMixin";
    import MainMixin from "../../../../mixins/mainMixin";
    import ValidatorMixin from "../../../../mixins/validatorMixin";

    export default {
        name: "membershipDocumentInformation",
        mixins: [OptionDataMixin, MainMixin, ValidatorMixin],
        data() {
            return {};
        },
        computed: {
            datas(){
                return this.$store.state.membership.tab_items
            }
        },  
        methods: {},
        watch: {}
    };
</script>
